import styled, {css} from 'styled-components'

export const StyledPicture = styled.picture`
  display: block;
  ${({blur}) =>
    blur
      ? css`
          filter: blur(${blur}px);
        `
      : ''}
`

export const StyledImg = styled.img`
  display: block;
  ${({objectFit, objectPosition}) =>
    objectFit
      ? css`
          height: 100%;
          width: 100%;
          object-fit: ${objectFit};
          object-position: ${objectPosition};
          font-family: 'object-fit: ${objectFit}; object-position: ${objectPosition};';
        `
      : ''}
`
